export default "__VITE_ASSET__298b31e4__"